/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable react/jsx-sort-props */
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

import { observer } from 'mobx-react-lite';

import CampaignView from '../components/Campaign/CampaignView';
import { ImageController } from '../components/Campaign/ImageController';
import { LiveUsersController } from '../components/Campaign/LiveUsersController';
import { MessageController } from '../components/Campaign/MessageController';
import { RtvUiController } from '../components/Campaign/RtvUiController';
import { TelemetryController } from '../components/Campaign/TelemetryController';
import CampaignDashboardLayout from '../components/layout/CampaignDashboardLayout';
import { DroneProfileService } from '../services/DroneProfileService';
import campaignStore from '../stores/CampaignStore';
import organizationStore from '../stores/OrganizationStore';

const Campaign: React.FC = observer(() => {
  const { selectedOrg } = organizationStore;
  const navigate = useNavigate();
  const { id } = useParams<{ id: string }>();
  const { t } = useTranslation();

  const [droneUuid, setDroneUuid] = useState<string>('');

  const campaign = campaignStore.campaigns.find(c => c.id === id);

  useEffect(() => {
    if (!campaign) {
      navigate('/campaigns');
    }
  }, [campaign]);

  if (!selectedOrg || !campaign) {
    toast.error(t("selected_organization_or_campaign_not_found"));
    return null;
  }

  useEffect(() => {
    const getDroneSerial = async (): Promise<void> => {
      const droneId = campaign.drones?.[0];
      const result = await DroneProfileService.getDroneProfileById(droneId);

      if (result.success) {
        setDroneUuid(result.data.device_uuid);
      }
      else {
        toast.error(t('campaign_view.errors.invalid_drone_serial'));
      }
    }
    getDroneSerial();
  }, []);

  return (
    <CampaignDashboardLayout>
      <TelemetryController campaignId={campaign.id} orgId={selectedOrg} droneUuid={droneUuid} />
      <LiveUsersController campaignId={campaign.id} orgId={selectedOrg} />
      <ImageController campaignId={campaign.id} orgId={selectedOrg} droneUuid={droneUuid} />
      <RtvUiController campaignId={campaign.id} orgId={selectedOrg} droneUuid={droneUuid} />
      <MessageController campaignId={campaign.id} orgId={selectedOrg} />
      <CampaignView projectName='Campaigns' campaign={campaign} />
      {/** TODO replace Campaigns with Project Name */}
    </CampaignDashboardLayout>
  );
});

export default Campaign;
